import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSiteConfig } from '../services/siteConfigService';
import { meetingService } from '../services/meetingService';
import { WORKSHOP_2026_PATH } from '../services/workshop2026Service';
import { useLocale } from '../context/LocaleContext';
import styles from '../styles/header.module.css';

interface WorkshopHeaderLinkProps {
  userEmail?: string | null;
}

function hasWorkshopRegistration(registrationState: string | undefined, isMember: boolean): boolean {
  if (!isMember) return false;
  const reg = (registrationState || 'none').trim().toLowerCase();
  return reg === 'interest' || reg === 'confirmed';
}

const WorkshopHeaderLink: React.FC<WorkshopHeaderLinkProps> = ({ userEmail }) => {
  const { t } = useLocale();
  const [visible, setVisible] = useState(false);
  const [useWorkshopTab, setUseWorkshopTab] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const site = await getSiteConfig();
        const code = (site.workshop_2026_meeting_code || '').trim();
        if (!code) {
          if (!cancelled) setVisible(false);
          return;
        }

        if (!cancelled) setVisible(true);

        if (!userEmail) {
          if (!cancelled) setUseWorkshopTab(false);
          return;
        }

        try {
          const status = await meetingService.getMemberStatus(code);
          if (!cancelled) {
            setUseWorkshopTab(hasWorkshopRegistration(status.registration_state, status.is_member));
          }
        } catch {
          if (!cancelled) setUseWorkshopTab(false);
        }
      } catch {
        if (!cancelled) setVisible(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userEmail]);

  if (!visible) return null;

  const to = useWorkshopTab ? `${WORKSHOP_2026_PATH}?tab=workshop` : WORKSHOP_2026_PATH;

  return (
    <Link to={to} className={styles.workshopHeaderLink}>
      {t('nav.workshop')}
    </Link>
  );
};

export default WorkshopHeaderLink;
